import { classnames, urlToValidHttps } from '@aibees/shared/utils';
import { Link } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { LinkButtonProps as Props } from './types';

export const LinkButton = memo(
  ({ className, href, target, variant, color, ...other }: Props) => {
    const path = urlToValidHttps(href);

    return (
      <Styled.Wrapper
        className={classnames('LinkButton', className)}
        {...(other as any)}
        component={Link}
        disabled={!href || other.disabled}
        color={color ?? 'primary'}
        variant={variant || 'text'}
        href={path}
        target={target || '_blank'}
        onClick={(e: any) => e.stopPropagation()}
      />
    );
  }
);

LinkButton.displayName = 'LinkButton';
